import { Box } from "@mui/material";
import React from "react";

export function ObjectHistorySpacerItem(){

    return (
        <Box sx={{
            height: "86px"
        }}>
        </Box>
    );
}
